import React, { useState } from "react";
import { VerifyTermApi } from "../../../../../../../../../services/Api/Organization/organizationTypes";
import {
	SubscriptionInvoiceApi,
	SubscriptionVisibility,
	SubscriptionsApi,
} from "../../../../../../../../../services/Api/Subscription/subscriptionTypes";
import { OrganizationMeApi } from "../../../../../../../../../services/Api/types";
import EmptySubscriptionsPreview from "../EmptySubscriptionsPreview";
import SubscriptionsInvoice from "../SubscriptionsInvoice";
import SubscriptionsInvoiceDetails from "../SubscriptionsInvoiceDetails";
import SubscriptionsPayment from "../SubscriptionsPayment";
import SubscriptionsSupport from "../SubscriptionsSupport";
import SingleSubscriptionMobilePreview from "./SingleSubscriptionMobilePreview";
import SubscriptionPreviewSummaryCard from "./SubscriptionPreviewSummaryCard";

interface Props {
	subscriptions: SubscriptionsApi;
	meDetails: OrganizationMeApi;
	onFetchOrganizationMeDetails?: () => void;
	invoices: SubscriptionInvoiceApi[];
	subscriptionsVisibility: SubscriptionVisibility;
	unpaidProformas: SubscriptionInvoiceApi[];
	termsToAccept: VerifyTermApi[];
}

const SubscriptionsMobilePreview = ({
	subscriptions,
	meDetails,
	invoices,
	subscriptionsVisibility,
	unpaidProformas,
	termsToAccept,
}: Props) => {
	const [updatedMeDetails, setUpdatedMeDetails] = useState<OrganizationMeApi>(meDetails);

	return (
		<div className={`subscriptions-preview mt-4`}>
			{subscriptionsVisibility !== SubscriptionVisibility.HIDDEN &&
				(subscriptions?.subscriptions.length > 0 ? (
					<div className="d-flex flex-column">
						{subscriptions.subscriptions.map((subscription, index) => (
							<SingleSubscriptionMobilePreview subscription={subscription} key={index} />
						))}
					</div>
				) : (
					<EmptySubscriptionsPreview subscriptionsVisibility={subscriptionsVisibility} />
				))}
			<SubscriptionPreviewSummaryCard
				subscriptions={subscriptions}
				subscriptionsVisibility={subscriptionsVisibility}
				unpaidProformas={unpaidProformas}
				termsToAccept={termsToAccept}
			/>
			<div className="row">
				<div className="col-md-6 mb-2">
					<SubscriptionsPayment invoices={invoices} />
				</div>
				<div className="col-md-6 mb-2">
					<SubscriptionsInvoiceDetails
						meDetails={updatedMeDetails}
						customer={subscriptions.customer}
						onFetchOrganizationMeDetails={(data) => setUpdatedMeDetails(data)}
					/>
				</div>
				<div className="col-md-6 mb-2">
					<SubscriptionsInvoice
						unPaidProformas={unpaidProformas}
						invoices={invoices}
						subscriptionsVisibility={subscriptionsVisibility}
					/>
				</div>
				<div className="col-md-6 mb-2">
					<SubscriptionsSupport />
				</div>
			</div>
		</div>
	);
};

export default SubscriptionsMobilePreview;
